import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Save, ShutterSpeed } from "@mui/icons-material";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import { invokeIfCallable } from "../../library/shared";
import { handleFreeze } from "../../utils/common";
import { useSelector } from "react-redux";

export const ThreeDot = ({
  onDelete,
  onEdit,
  onView,
  onPrint,
  onMarkIA,
  onMarkA,
  onCancel,
  onSave,
  onClose,
  onClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );
  const handleClick = (event) => {
    event?.stopPropagation();
    setAnchorEl(event.currentTarget);
    invokeIfCallable(onClick);
  };

  const handleClose = (e) => {
    e?.stopPropagation();
    setAnchorEl(null);
    invokeIfCallable(onClose);
  };

  const handleOptionClick = (optionCallback, event) => {
    event.stopPropagation();
    if (Freeze === 1) {
      return handleFreeze();
    }
    // Stop propagation here
    if (optionCallback && typeof optionCallback === "function") {
      optionCallback(event);
    }
    handleClose();
    event.stopPropagation(); // Stop propagation here
  };

  return (
    <>
      <IconButton
        sx={{ p: 0 }}
        aria-label="more"
        aria-controls="three-dot-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="three-dot-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClick}
      >
        <Box onMouseLeave={handleClose}>
          {onView && typeof onView === "function" && (
            <MenuItem
              sx={{
                minWidth: "110px",
                display: "flex",
                justifyContent: "space-between",
              }}
              onClick={(event) => handleOptionClick(onView, event)}
            >
              <Typography>View</Typography>{" "}
              <VisibilityIcon
                sx={{ fontSize: "15px", color: "primary.main" }}
              />
            </MenuItem>
          )}

          {onEdit && typeof onEdit === "function" && (
            <MenuItem
              sx={{
                minWidth: "110px",
                display: "flex",
                justifyContent: "space-between",
              }}
              onClick={(event) => handleOptionClick(onEdit, event)}
            >
              <Typography>Edit</Typography>{" "}
              <EditIcon sx={{ fontSize: "15px", color: "#6096d9" }} />
            </MenuItem>
          )}
          {onPrint && typeof onPrint === "function" && (
            <MenuItem
              sx={{
                minWidth: "110px",
                display: "flex",
                justifyContent: "space-between",
              }}
              onClick={(event) => handleOptionClick(onPrint, event)}
            >
              <Typography>Print</Typography>{" "}
              <PrintIcon sx={{ fontSize: "15px", color: "#6096d9" }} />
            </MenuItem>
          )}
          {onMarkIA && typeof onMarkIA === "function" && (
            <MenuItem
              sx={{
                minWidth: "110px",
                display: "flex",
                justifyContent: "space-between",
              }}
              onClick={(event) => handleOptionClick(onMarkIA, event)}
            >
              <Typography>Mark As In-Active</Typography>{" "}
              <ShutterSpeed sx={{ fontSize: "15px", color: "#6096d9" }} />
            </MenuItem>
          )}
          {onMarkA && typeof onMarkA === "function" && (
            <MenuItem
              sx={{
                minWidth: "110px",
                display: "flex",
                justifyContent: "space-between",
              }}
              onClick={(event) => handleOptionClick(onMarkA, event)}
            >
              <Typography>Mark As Active</Typography>{" "}
              <ShutterSpeed sx={{ fontSize: "15px", color: "#6096d9" }} />
            </MenuItem>
          )}
          {onCancel && typeof onCancel === "function" && (
            <MenuItem
              sx={{
                minWidth: "110px",
                display: "flex",
                justifyContent: "space-between",
              }}
              onClick={(event) => handleOptionClick(onCancel, event)}
            >
              <Typography>Cancel</Typography>{" "}
              <CancelPresentationIcon
                sx={{ fontSize: "15px", color: "#6096d9" }}
              />
            </MenuItem>
          )}
          {onDelete && typeof onDelete === "function" && (
            <MenuItem
              sx={{
                minWidth: "110px",
                display: "flex",
                justifyContent: "space-between",
              }}
              onClick={(event) => handleOptionClick(onDelete, event)}
            >
              <Typography>Delete</Typography>{" "}
              <DeleteIcon sx={{ fontSize: "15px", color: "#eb6a6a" }} />
            </MenuItem>
          )}
          {onSave && typeof onSave === "function" && (
            <MenuItem
              sx={{
                minWidth: "110px",
                display: "flex",
                justifyContent: "space-between",
              }}
              onClick={(event) => handleOptionClick(onSave, event)}
            >
              <Typography>Save</Typography>{" "}
              <Save sx={{ fontSize: "15px", color: "#6AB937" }} />
            </MenuItem>
          )}
        </Box>
      </Menu>
    </>
  );
};
